module.exports = __webpack_public_path__ + "f931c77df8a2c310fbc1e7a1aa2c5899.svg";